module.exports = __webpack_public_path__ + "static/media/demo5.4938fc74.png";